var api = require("!./node_modules/.store/style-loader@1.3.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!./node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/cjs.js!./node_modules/.store/less-loader@6.2.0/node_modules/less-loader/dist/cjs.js!./index.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};